module.exports = __webpack_public_path__ + "img/icon_short_link.d90fabf3.png";